<fin-block-offer-tile
  (linkClicked)="onLinkClick($event)"
  (amContinueModalClick)="flightHotelClicked.emit($event)"
  class="fill block flex slim"
  [blockOffer$]="blockOffer$"
  [tripType]="tripType"
>
</fin-block-offer-tile>
